<app-card-v2 [variant]="cardVariant" title="Erreur">
    <app-error-text
        [message]="inputMessage"
        [error]="error"
    ></app-error-text>
</app-card-v2>
